import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KeycloakUser, LoginResponse } from '../../types/user';
import { LanguageDto } from '../../types/language';
import { InitDto } from '../../types/common';

interface GlobalState {
    loggedUser: KeycloakUser | null;
    loggedUserId: string | null;
    /** JWT access token — lives in Redux memory only, never in localStorage */
    apiToken: string | null;
    languages: LanguageDto[];
    initDone: boolean;
}

const initialState: GlobalState = {
    loggedUser: null,
    loggedUserId: null,
    apiToken: null,
    languages: [],
    initDone: false,
};

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        initFromKeycloak: (state, action: PayloadAction<KeycloakUser>) => {
            state.loggedUser = action.payload;
            state.loggedUserId = action.payload.sub;
        },
        finishLogin: (state, action: PayloadAction<LoginResponse>) => {
            // Token stored only in Redux memory (never in localStorage) per security policy
            state.apiToken = action.payload.token ?? null;
        },
        doLogout: (state) => {
            state.loggedUser = null;
            state.loggedUserId = null;
        },
        saveInit: (state, action: PayloadAction<InitDto>) => {
            state.languages = action.payload.languages;
            state.initDone = true;
        },
    },
});

export const { initFromKeycloak, finishLogin, doLogout, saveInit } = globalSlice.actions;
export default globalSlice.reducer;
